export const adminSelectorTranslations = {
  title: 'My companies',
  contact_text: 'To add a company',
  contact_link: 'contact us',
  accessibility: {
    current_company: 'Current company: %{name}',
    switch_to: 'Switch to %{name}',
    companies: 'Companies',
  },
};
